import jwtDecode from 'jwt-decode';
import SuperFetch from './superFetch';
import { apiUrls } from '../settings';

class AuthHelper {

  login = async userInfo => {
    if (!userInfo.email || !userInfo.password) {
      return { error: 'please fill in the input' };
    }
    return await SuperFetch.post(apiUrls.login, userInfo).then(response =>
      this.checkExpirity(response.token)
    );
  };

  register = async userInfo => {
    if (!userInfo.email || !userInfo.password || !userInfo.firstname || !userInfo.lastname) {
      return { error: 'please fill in the required inputs' };
    }
    return await SuperFetch.post(apiUrls.signup, userInfo).then(response =>
      this.checkExpirity(response.token)
    );
  };

  async checkDemoPage(token) {
    if (this.checkExpirity(token).error) {
      return { error: 'Token expired' };
    }
    return await SuperFetch.post('secret/test', { token })
      .then(response => response)
      .catch(error => ({ error: JSON.stringify(error) }));
  }

  checkExpirity = token => {
    if (!token) {
      return {
        error: 'Either the username or password is incorrect',
      };
    }
    try {
      const profile = jwtDecode(token);
      const expiredAt = profile.exp * 1000;
      if (expiredAt > Math.floor(new Date().getTime()))
        return {
          ...profile,
          token,
          expiredAt: new Date(expiredAt),
        };
      else {
        return { error: 'Token expired' };
      }
    } catch (e) {
      return { error: 'Server Error' };
    }
  };
}
export default new AuthHelper();



// WEBPACK FOOTER //
// ./src/helpers/authHelper.js